import { render } from "./expertreview.vue?vue&type=template&id=ca6d424a"
import script from "./expertreview.vue?vue&type=script&lang=js"
export * from "./expertreview.vue?vue&type=script&lang=js"

import "./expertreview.vue?vue&type=style&index=0&id=ca6d424a&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__